import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { combineForms } from 'react-redux-form';
import counterReducer from '../features/counter/counterSlice';
import * as Translation from '../app/store/external/translation-reducer/translation.reducer';
import * as authenticationReducer from '../app/store/user-login.reducer';
import { reducer as oidcReducer } from 'redux-oidc';
//external
import * as NavMenu from '../app/store/external/nav-menu-reducer/nav-menu.reducer';

//external - common
import * as fileAttachmentReducer from '../app/store/external/common-reducer/file-attachment.reducer';
//external - request
import * as requestLogReducer from '../app/store/external/request-reducer/request-log.reducer';
import * as requestDetailReducer from '../app/store/external/request-reducer/request-details.reducer';
import * as SideNavMenu from '../app/store/external/side-nav-menu-reducer/side-nav-menu.reducer';
import * as CircuitUsage from '../app/store/external/circuit-usage-reducer/circuit-usage.reducer'
import * as createRequestReducer from '../app/store/external/request-reducer/create-request.reducer';
//external - request - wireless
import * as newMobileSubscriptionReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/new-mobile-subscription.reducer';
import * as wirelessChangeVendorReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-vendor.reducer';
import * as wirelessChangeUserReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-user.reducer';
import * as wirelessChangePricePlanReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-price-plan.reducer';
import * as wirelessOtherReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-other.reducer';
import * as wirelessPortInReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-port-in.reducer';
import * as wirelessPortOutReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-portout.reducer';
import * as wirelessReplaceDeviceReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-replace-device.reducer';
import * as wirelessReplaceSimReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-replace-sim.reducer';
import * as wirelessTerminateReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-terminate-subscription.reducer';
import * as wirelessAccessoryReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-accessory.reducer';
import * as wirelessIntlRoamingAccessReducer from './../app/store/external/request-reducer/order-request-reducer/wireless-request/wireless-intl-roaming-access.reducer';
//external - request - wireline
import * as wirelineChangeVendorReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-change-vendor.reducer';
import * as wirelineUpgradeCircuitReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-upgrade-circuit.reducer';
import * as wirelineTerminateCircuitReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate-circuit.reducer';
import * as wirelineTerminateExhibitBReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate/wireline-terminate-exhibit-b.reducer';
import * as wirelineOtherRequestReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-other-request.reducer';
import * as newCircuitSubscriptionReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer';
import * as newCircuitExhibitBReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-exhibit-b.reducer';
import * as newQuotationReducer from './../app/store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer';
//external - release notes
import * as releaseNotesReducer from './store/external/release-notes-reducer/release-notes-reducer'

import * as csatSurveyReducer from './store/external/csat-survey-reducer/csat-survey.reducer';
import * as inventoryCircuitReducer from './store/external/inventory/circuit.reducer';
import * as inventoryASRReducer from './store/external/inventory/asr.reducer';
import * as inventoryASPUReducer from './store/external/inventory/aspu.reducer';
import * as inventoryEquipmentReducer from './store/external/inventory/equipment.reducer';
import * as inventoryOrderHistoryReducer from './store/external/inventory/history/order-history.reducer';
import * as inventoryCostAllocationReducer from './store/external/inventory/add-cost-allocation.reducer';
import * as inventoryUsageSpendReducer from './store/external/inventory/usagespend.reducer';

import * as inventoryCircuitHistoryReducer from './store/external/inventory/history/circuit-history.reducer';
import * as inventoryEquipmentHistoryReducer from './store/external/inventory/history/equipment-history.reducer';
import * as inventoryCircuitSIMReducer from './store/external/inventory/details-view/add-sim.reducer';
import * as inventoryCircuitEquipReducer from './store/external/reports-reducer/inventory/details-view/add-equipment.reducer';
import * as inventoryLinkedCircuitReducer from './store/external/inventory-reducer/linked-circuits.reducer';
import * as inventoryCircuitAccessInformationReducer from './store/external/inventory/details-view/access-information.reducer';
import * as inventoryCircuitPIPInformationReducer from './store/external/inventory/details-view/pip-information.reducer';
import * as inventoryCircuitPlanDetailsReducer from './store/external/inventory/details-view/add-plan-details.reducer';
import * as inventoryCircuitInvoiceReducer from './store/external/inventory/invoice/invoice.reducer';
import * as invoiceAccountPayableReducer from './store/external/invoice/account-payable/account-payable.reducer';
import * as locationSiteReducer from './store/external/inventory/locationsite.reducer';

import * as InventoryUploadReducer from './store/external/inventory/inventory-upload/inventory-upload.reducer'

import * as invoiceDisputeDetailseReducer from './store/external/invoice/dispute/dispute-details.reducer';
import * as invoiceDisputeCommentsReducer from './store/external/invoice/dispute/dispute-comments.reducer';
import * as invoiceDisputeHistoryReducer from './store/external/invoice/dispute/dispute-history.reducer';

import * as invoiceDisputeReducer from './store/external/invoice/dispute.reducer';

import * as invoiceDisputeFollowUpReducer from './store/external/invoice/dispute/dispute-followup.reducer';

import * as invoiceUploadReducer from './store/external/invoice/invoice-upload/invoice-upload.reducer';
import * as chargeMappingReducer from './store/external/invoice/invoice-upload/charge-mapping.reducer';

import * as invoiceInvoiceReducer from './store/external/invoice/invoice.reducer';
import * as invoiceInvoiceDetailsReducer from './store/external/invoice/invoice/invoice-details.reducer';
import * as invoiceLineItemsReducer from './store/external/invoice/invoice/line-items.reducer';
import * as invoiceAuditRulesReducer from './store/external/invoice/invoice/audit-table.reducer';
import * as invoiceCommentReducer from './store/external/invoice/invoice/invoice-comments.reducer'
import * as invoiceAuditReducer from './store/external/invoice/invoice/invoice-audit.reducer'
import * as invoiceHistoryReducer from './store/external/invoice/invoice/invoice-history.reducer';

//Manage User
import * as manageUserReducer from './store/external/manage-user/manage-user.reducer';
import * as manageUserHrDetailsReducer from './store/external/manage-user/form/manage-user-form.reducer';
import * as manageUserCostAllocationReducer from './store/external/manage-user/form/user-add-cost-allocation.reducer';
import * as manageUserCommentReducer from './store/external/manage-user/manage-user-comments.reducer';
import * as manageUserHistoryReducer from './store/external/manage-user/manage-user-history.reducer';

import * as hrUploadReducer from './store/external/manage-user/hr-upload/hr-upload.reducer';

import * as adminSettingReducer from './store/admin-setting.reducer';

import * as invoiceSubLineReducer from './store/external/invoice/subline-item.reducer';

import * as notificationReducer from './store/common/header-navigation/header/notification.reducer';

// Orders Tab
import * as orderOrderReducer from './store/external/order/order.reducer';
import * as orderMilestoneReducer from './store/external/order/milestone/order-milestone.reducer';
import * as orderDetailsReducer from './store/external/order/order-details.reducer';
import * as circuitOrderReducer from './store/external/order/order-circuit.reducer';
import * as circuitOrderInventoryCircuitPlanDetailsReducer from './store/external/inventory/details-view/add-plan-details.reducer';
import * as circuitOrderInventoryCircuitSIMReducer from './store/external/inventory/details-view/add-sim.reducer';
import * as circuitOrderInventoryCircuitEquipReducer from './store/external/reports-reducer/inventory/details-view/add-equipment.reducer';
import * as circuitOrderInventoryCostAllocationReducer from './store/external/inventory/add-cost-allocation.reducer';
import * as circuitOrderAccessInformationReducer from './store/external/inventory/details-view/access-information.reducer';
import * as circuitOrderPIPInformationReducer from './store/external/inventory/details-view/pip-information.reducer';

import * as orderDetailsComments from './store/external/order/order-details-comments.reducer';
import * as orderHistoryReducer from './store/external/order/history/order-history.reducer';

// Finance Tab
import * as rateCardReducer from './store/external/finance/rate-card.reducer';
import * as rateCardUploadReducer from './store/external/finance/rate-card-upload.reducer';
import * as glCodeReducer from './store/external/finance/gl-code.reducer';
import * as costCenterReducer from './store/external/finance/cost-code.reducer';
import * as glCodeDetailsReducer from './store/external/finance/glcode-details/gl-code-details.reducer';
import * as glCodeHistoryReducer from '././store/external/finance/glcode-details/gl-code-history.reducer';
import * as costCenterHistoryReducer from './store/external/finance/history/cost-center-history.reducer';
import * as filterReducer from './store/external/filter-reducer/filter-reducer';
import * as planCatalogueReducer from './store/external/finance/plan-catalogue.reducer';
import * as planCatalogueHistoryReducer from './store/external/finance/history/plan-catalogue-history.reducer';
import * as billingAccountReducer from './store/external/finance/billing-account.reducer';
import * as billingAccountDetailsReducer from './store/external/finance/billing-account/billing-account-details.reducer';
import * as billingAccountCostAllocation from './store/external/inventory/add-cost-allocation.reducer';
import * as billingAccountHistoryReducer from './store/external/finance/billing-account/billing-account-history.reducer';
import * as contractReducer from './store/external/finance/contract.reducer';
import * as contractDetailsReducer from './store/external/finance/contract/contract-details.reducer';
import * as contractHistoryReducer from './store/external/finance/contract/contract-details-history.reducer';

// Recharging Tab
import * as debitorCatalogueReducer from './store/external/recharge-reducer/debitor-catalogue-reducer/debitor-catalogue.reducer';
import * as debitoryHistoryreducer from './store/external/recharge-reducer/history/debitor-history-reducer';
import * as debitorUploadReducer from './store/external/recharge-reducer/debitor-catalogue-upload-reducer/debitor-catalogue-upload-reducer';
import * as articleUploadReducer from './store/external/recharge-reducer/article-upload-reducer/article-upload.reducer';
import * as articleCatalogueReducer from './store/external/recharge-reducer/article-catalogue-reducer/article-catalogue.reducer';
import * as articleCatalogueMilestoneReducer from './store/external/recharge-reducer/article-catalogue-milestone.reducer/article-catalogue-milestone.reducer';
import * as articleHistoryreducer from './store/external/recharge-reducer/history/article-history-reducer';
import * as rechargingInventoryreducer from './store/external/recharge-reducer/recharging-inventory-reducer/recharging-inventory-reducer';
import * as rechargeInventoryDetailsReducer from './store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';
import * as rechargingHistoryreducer from './store/external/recharge-reducer/history/recharging-inventory-history-reducer';
import * as outputConfigurationreducer from './store/external/recharge-reducer/output-configuration-reducer/output-configuration.reducer';
import * as outputConfigurationDetailsReducer from './store/external/recharge-reducer/output-configuraton-details/output-configuration-details.reducer';
import * as outputComment from './store/external/recharge-reducer/output-configuration-reducer/output-configuration-comments.reducer';
import * as configOutputRecordsReducer from './store/external/recharge-reducer/output-configuration-reducer/output-configuration-output-records.reducer';
import * as outputConfigHistoryReducer from './store/external/recharge-reducer/output-configuration-reducer/output-configuration-history.reducer';
import * as outputConfigRechargeItemsReducer from './store/external/recharge-reducer/output-configuration-reducer/output-configuration-recharge-items.reducer';
import * as outputRecordReducer from './store/external/recharge-reducer/output-record.reducer/output-record.reducer'
import * as stripeReducer from './store/common/stripe/stripe.reducer';
import * as chatbotReducer from './store/common/chatbot/chatbot.reducer';


const rootReducer = combineReducers({
    routing: routerReducer
    , counter: counterReducer
    , adminSetting: adminSettingReducer.reducer
    , authentication: authenticationReducer.reducer
    , oidc: oidcReducer
    //external - request
    , requestLog: requestLogReducer.reducer
    , requestDetail: requestDetailReducer.reducer
    , translation: Translation.reducer

    //external:home
    , navMenu: NavMenu.reducer
    , sideNavMenu: SideNavMenu.reducer

    //external:common
    , fileAttachment: fileAttachmentReducer.reducer
    , releaseNotes: releaseNotesReducer.reducer
    , filter: filterReducer.reducer
    //external:request
    , circuitUsage: CircuitUsage.reducer
    , createRequest: createRequestReducer.reducer
    //external:request - wireless
    , newMobileRequest: newMobileSubscriptionReducer.reducer
    , wirelessChangeVendorRequest: wirelessChangeVendorReducer.reducer
    , wirelessChangeUserRequest: wirelessChangeUserReducer.reducer
    , wirelessChangePricePlanRequest: wirelessChangePricePlanReducer.reducer
    , wirelessOtherRequest: wirelessOtherReducer.reducer
    , wirelessPortOutRequest: wirelessPortOutReducer.reducer
    , wirelessPortInRequest: wirelessPortInReducer.reducer
    , wirelessReplaceDeviceRequest: wirelessReplaceDeviceReducer.reducer
    , wirelessReplaceSimRequest: wirelessReplaceSimReducer.reducer
    , wirelessTerminateRequest: wirelessTerminateReducer.reducer
    , wirelessAccessoryRequest: wirelessAccessoryReducer.reducer
    , wirelessIntlRoamingAccessRequest: wirelessIntlRoamingAccessReducer.reducer
    //external:request - wireline
    , wirelineChangeVendorRequest: wirelineChangeVendorReducer.reducer
        //terminate
    , wirelineTerminateCircuitRequest: wirelineTerminateCircuitReducer.reducer
    , wirelineTerminateExhibitBRequest: wirelineTerminateExhibitBReducer.reducer
        //upgrade
    , wirelineUpgradeCircuitRequest: wirelineUpgradeCircuitReducer.reducer
        //other
    , wirelineOtherRequestRequest: wirelineOtherRequestReducer.reducer
        //new circuit
    , newCircuitRequest: newCircuitSubscriptionReducer.reducer
    , newCircuitExhibitBRequest: newCircuitExhibitBReducer.reducer
        //quotation
    , quotationRequest: newQuotationReducer.reducer
    //END external:request - wireline

    , csatSurveyRequest: csatSurveyReducer.reducer

    // inventory tab
    , inventoryCircuit: inventoryCircuitReducer.reducer
    , inventoryEquipment: inventoryEquipmentReducer.reducer
    , inventoryASPU: inventoryASPUReducer.reducer
    , inventoryASR: inventoryASRReducer.reducer
    , inventoryOrderHistory: inventoryOrderHistoryReducer.reducer
    , inventoryUsageSpend: inventoryUsageSpendReducer.reducer

    , inventoryCircuitHistory: inventoryCircuitHistoryReducer.reducer
    , inventoryEquipmentHistory: inventoryEquipmentHistoryReducer.reducer
    , inventoryCircuitSIM: inventoryCircuitSIMReducer.reducer
    , inventoryCircuitEquip: inventoryCircuitEquipReducer.reducer
    , inventoryCostAllocation: inventoryCostAllocationReducer.reducer
    , inventoryLinkedCircuit: inventoryLinkedCircuitReducer.reducer
    , inventoryCircuitAccessInformation: inventoryCircuitAccessInformationReducer.reducer
    , inventoryCircuitPIPInformation: inventoryCircuitPIPInformationReducer.reducer
    , inventoryCircuitPlanDetails: inventoryCircuitPlanDetailsReducer.reducer

    , inventoryCircuitInvoice: inventoryCircuitInvoiceReducer.reducer
    , locationSite: locationSiteReducer.reducer

    , invoiceAccountPayableDetails: invoiceAccountPayableReducer.reducer
    , inventoryUpload: InventoryUploadReducer.reducer

    // invoice tab
    , invoiceInvoice: invoiceInvoiceReducer.reducer
    , invoiceInvoiceDetails: invoiceInvoiceDetailsReducer.reducer
    , invoiceLineItems: invoiceLineItemsReducer.reducer
    , invoiceAuditRules: invoiceAuditRulesReducer.reducer
    , invoiceInvoiceComments: invoiceCommentReducer.reducer
    , invoiceInvoiceAudit: invoiceAuditReducer.reducer
    , invoiceUpload: invoiceUploadReducer.reducer
    , chargeMappingUpload: chargeMappingReducer.reducer

    , invoiceDispute: invoiceDisputeReducer.reducer
    , invoiceDisputeDetails: invoiceDisputeDetailseReducer.reducer
    , invoiceDisputeComments: invoiceDisputeCommentsReducer.reducer
    , invoiceDisputeFollowUpDetails: invoiceDisputeFollowUpReducer.reducer
    , invoiceDisputeHistory: invoiceDisputeHistoryReducer.reducer
    , invoiceSubLine: invoiceSubLineReducer.reducer

    // orders tab
    , orderOrder: orderOrderReducer.reducer
    , orderMilestoneDetails: orderMilestoneReducer.reducer
    , orderDetails: orderDetailsReducer.reducer
    , circuitOrder: circuitOrderReducer.reducer
    , circuitOrderInventoryCircuitPlanDetails: circuitOrderInventoryCircuitPlanDetailsReducer.reducer
    , circuitOrderInventoryCircuitSIM: circuitOrderInventoryCircuitSIMReducer.reducer
    , circuitOrderInventoryCircuitEquip: circuitOrderInventoryCircuitEquipReducer.reducer
    , circuitOrderInventoryCostAllocation: circuitOrderInventoryCostAllocationReducer.reducer
    , circuitOrderAccessInformation: circuitOrderAccessInformationReducer.reducer
    , circuitOrderPIPInformation: circuitOrderPIPInformationReducer.reducer
    , orderDetailsComments: orderDetailsComments.reducer
    , orderHistory: orderHistoryReducer.reducer
    , notification: notificationReducer.reducer
    , invoiceHistory: invoiceHistoryReducer.reducer

    //HR Management Tab
    , manageUser: manageUserReducer.reducer
    , manageUserHrDetails: manageUserHrDetailsReducer.reducer
    , manageUserComments: manageUserCommentReducer.reducer
    , manageUserCostAllocation: manageUserCostAllocationReducer.reducer
    , manageUserHistory: manageUserHistoryReducer.reducer

    , hrUpload: hrUploadReducer.reducer

    // Finance tab
    , rateCard: rateCardReducer.reducer
    , rateCardUpload: rateCardUploadReducer.reducer
    , glCode: glCodeReducer.reducer
    , costCenter: costCenterReducer.reducer
    , glCodeDetails: glCodeDetailsReducer.reducer
    , glCodeHistory: glCodeHistoryReducer.reducer
    , costCenterHistory: costCenterHistoryReducer.reducer
    , planCatalogue: planCatalogueReducer.reducer
    , planCatalogueHistory: planCatalogueHistoryReducer.reducer
    , billingAccount: billingAccountReducer.reducer
    , billingAccountDetails: billingAccountDetailsReducer.reducer
    , billingAccountHistory: billingAccountHistoryReducer.reducer
    , contract: contractReducer.reducer
    , contractDetails: contractDetailsReducer.reducer
    , contractHistory: contractHistoryReducer.reducer

    // Recharging Tab
    , debitorCatalogue: debitorCatalogueReducer.reducer
    , debitorHistory: debitoryHistoryreducer.reducer
    , debitorUpload: debitorUploadReducer.reducer
    , articleUpload: articleUploadReducer.reducer
    , articleCatalogue: articleCatalogueReducer.reducer
    , articleCatalogueMilestone: articleCatalogueMilestoneReducer.reducer
    , articleHistory: articleHistoryreducer.reducer
    , rechargingInventory: rechargingInventoryreducer.reducer
    , rechargeInventoryDetails: rechargeInventoryDetailsReducer.reducer
    , rechargingHistory: rechargingHistoryreducer.reducer
    , outputConfiguration: outputConfigurationreducer.reducer
    , outputConfigurationDetails: outputConfigurationDetailsReducer.reducer
    , outputComment: outputComment.reducer
    , configOutputRecords: configOutputRecordsReducer.reducer
    , outputConfigHistory: outputConfigHistoryReducer.reducer
    , outputConfigRechargeItems: outputConfigRechargeItemsReducer.reducer
    , outputRecord: outputRecordReducer.reducer

    //Stripe
    , stripeDetails: stripeReducer.reducer
    , chatbot: chatbotReducer.reducer


    //forms
    , form: combineForms({
        // WIRELESS
        // new mobile request
        wirelessLocationFormA: newMobileSubscriptionReducer.locationModelAInitialState
        , wirelessSubscriptionFormA: newMobileSubscriptionReducer.subscriptionModelAInitialState
        , wirelessBusinessFormA: newMobileSubscriptionReducer.businessModelAInitialState
        // port in
        , wirelessPortInLocationFormA: wirelessPortInReducer.portInLocationModelAInitialState
        , wirelessPortInSubscriptionFormA: wirelessPortInReducer.portInSubscriptionModelAInitialState
        , wirelessPortInBusinessFormA: wirelessPortInReducer.portInBusinessModelAInitialState
        //  change vendor
        , wirelessChangeVendorFormA: wirelessChangeVendorReducer.changeVendorModelAInitialState
        //  change price plan
        , wirelessChangePricePlanFormA: wirelessChangePricePlanReducer.changePricePlanModelAInitialState
        //  change user
        , wirelessChangeUserFormA: wirelessChangeUserReducer.changeUserModelAInitialState
        //  other
        , wirelessOtherFormA: wirelessOtherReducer.otherModelAInitialState
        //  port-out
        , wirelessPortOutFormA: wirelessPortOutReducer.portOutModelAInitialState
        //  replace device
        , wirelessReplaceDeviceFormA: wirelessReplaceDeviceReducer.replaceDeviceModelAInitialState
        //  replace sim
        , wirelessReplaceSimFormA: wirelessReplaceSimReducer.repalceSimModelAInitialState
        //  terminate
        , wirelessTerminateFormA: wirelessTerminateReducer.terminateModelAInitialState
        // accessory
        , wirelessAccessoryForm: wirelessAccessoryReducer.accessoryModelInitialState
        // international roaming access
        , wirelessIntlRoamingAccessForm: wirelessIntlRoamingAccessReducer.intlRoamingAccessModelInitialState
        // END WIRELESS

        // WIRELINE
        //new circuit
        , wirelineLocationFormA: newCircuitSubscriptionReducer.wirelineLocationModelAInitialState
        , wirelineSubscriptionFormA: newCircuitSubscriptionReducer.wirelineSubscriptionModelAInitialState
        , wirelineBusinessFormA: newCircuitSubscriptionReducer.wirelineBusinessModelAInitialState
        // new circuit exhibit b
        , wirelineLocationFormB: newCircuitExhibitBReducer.wirelineLocationModelBInitialState
        , wirelineSubscriptionFormB: newCircuitExhibitBReducer.wirelineSubscriptionModelBInitialState
        , wirelineBusinessFormB: newCircuitExhibitBReducer.wirelineBusinessModelBInitialState
        // quotation
        , quotationLocationFormA: newQuotationReducer.quotationLocationModelAInitialState
        , quotationSubscriptionFormA: newQuotationReducer.quotationSubscriptionModelAInitialState
        , quotationBusinessFormA: newQuotationReducer.quotationBusinessModelAInitialState
        //  change vendor
        , wirelineChangeVendorFormA: wirelineChangeVendorReducer.changeVendorModelAInitialState
        //  upgrade circuit
        , wirelineUpgradeCircuitFormA: wirelineUpgradeCircuitReducer.upgradeCircuitModelA
        //  terminate
        , wirelineTerminateCircuitFormA: wirelineTerminateCircuitReducer.terminateCircuitModelAInitialState
        , wirelineTerminateCircuitFormB: wirelineTerminateExhibitBReducer.terminateCircuitModelBInitialState
        //  other request
        , wirelineOtherRequestFormA: wirelineOtherRequestReducer.otherRequestModelAInitialState
        // END WIRELINE

        // INVENTORY
        , inventoryCircuitForm: {
            circuitDetails: inventoryCircuitReducer.circuitDetailsFormInitialState,
            location1: inventoryCircuitReducer.location1FormInitialState,
            location2: inventoryCircuitReducer.location2FormInitialState,
            accessInformation: inventoryCircuitAccessInformationReducer.accessInformationFormInitialState,
            pipInformation: inventoryCircuitPIPInformationReducer.pipInformationFormInitialState
        }
        , inventoryCicuitPlanDetailsForm: inventoryCircuitPlanDetailsReducer.planDetailsFormInitialState
        , inventoryCircuitSIMForm: inventoryCircuitSIMReducer.circuitSimFormInitialState
        , inventoryCircuitEquipForm: inventoryCircuitEquipReducer.circuitEquipFormInitialState
        , inventoryCircuitCostAllocationForm: inventoryCostAllocationReducer.circuitCostAllocationFormInitialState
        , inventoryEquipmentForm: inventoryEquipmentReducer.equipmentInitialState
        , invoiceDisputeDetailsForm: invoiceDisputeDetailseReducer.disputeDetailsFormInitialState
        , invoiceDisputeFollowUpForm: invoiceDisputeFollowUpReducer.disputeFollowUpFormInitialState
        , invoiceInvoiceDetailsForm: invoiceInvoiceDetailsReducer.invoiceDetailsFormInitialState

        //INVETORY UPLOAD
        , inventoryUploadForm: InventoryUploadReducer.InventoryUploadFormInitialState

        //Invoice
        , invoiceUploadForm: invoiceUploadReducer.invoideUpdateFormInitialState
        , chargeMappingForm: chargeMappingReducer.chargeMappingFormInitialState

        //Order
        , orderDetailsForm: orderDetailsReducer.orderDetailsInitialFormState
        , orderMilestoneForm: orderMilestoneReducer.orderMilestoneFormInitialState
        , circuitOrderForm: {
            circuitOrderDetails: circuitOrderReducer.circuitOrderInitialFormState,
            circuitOrderLocation1: circuitOrderReducer.location1FormInitialState,
            circuitOrderLocation2: circuitOrderReducer.location2FormInitialState,
        }
        , circuitOrderPipForm: circuitOrderPIPInformationReducer.pipInformationFormInitialState
        , circuitOrderAccessForm: circuitOrderAccessInformationReducer.accessInformationFormInitialState
        , circuitOrderPlanDetailsForm: circuitOrderInventoryCircuitPlanDetailsReducer.planDetailsFormInitialState
        , circuitOrderSIMForm: circuitOrderInventoryCircuitSIMReducer.circuitSimFormInitialState
        , circuitOrderEquipForm: circuitOrderInventoryCircuitEquipReducer.circuitEquipFormInitialState
        , circuitOrderCostAllocationForm: circuitOrderInventoryCostAllocationReducer.circuitCostAllocationFormInitialState

        //Finance
        , glCodeDetailsForm: glCodeDetailsReducer.glCodeDetailsFormState
        , planCatalogueDetailsForm: planCatalogueReducer.planCatalogueDetailsInitialState
        , planComponentForm: planCatalogueReducer.planComponentInitialState
        , billingAccountForm: {
            billingAccount: billingAccountDetailsReducer.billingAccountInitalState
            , billingAddress: billingAccountDetailsReducer.billingAddressInitialState
            , remitAddress: billingAccountDetailsReducer.remitAddressInitialState
            , financeCostAllocation: billingAccountCostAllocation.circuitCostAllocationFormInitialState
        }
        , contractForm: {
            contract: contractDetailsReducer.contractInitalState
            , contractCommitment: contractDetailsReducer.contractCommitmentInitialState
        }

        //HR Management
        , manageUserHrDetailsForm: manageUserHrDetailsReducer.hrDetailsInitialFormState
        , manageUserCostAllocationForm: manageUserCostAllocationReducer.userCostAllocationFormInitialState
        , manageUserCostAllocationTableForm: manageUserCostAllocationReducer.userCostAllocationTableFormInitialState
        , hrUploadForm: hrUploadReducer.hrUploadFormInitialState

        //Rate Card Upload
        , rateCardUploadForm: rateCardUploadReducer.rateCardUploadFormInitialState

        //Finance Cost Allocation
        , financeCostCodeForm: costCenterReducer.costCenterInitialState

        //Recharging
        , debitorCatalogueForm: debitorCatalogueReducer.debitorCatalogueInitialState
        , debitorUploadForm: debitorUploadReducer.debitorCatalogueUploadFormInitialState
        , articleUploadForm: articleUploadReducer.articleUploadFormInitialState
        , articleCatalogueMilestoneForm: articleCatalogueMilestoneReducer.articleCatalogueMilestoneInitialState
        , rechargeInventoryDetailsForm: {
            rechargeInventory: rechargeInventoryDetailsReducer.rechargeInventoryDetailsInitialState
            , mappingInformation: rechargeInventoryDetailsReducer.mappingInformationInitialState
            , additionalInformation: rechargeInventoryDetailsReducer.additionalInformationInitialState
            , locationInformation: rechargeInventoryDetailsReducer.locationInformationInitialState
            , otcInformation: rechargeInventoryDetailsReducer.otcInformationInitialState
            , circuitInformation: rechargeInventoryDetailsReducer.circuitInformationInitialState
            , mrcInformation: rechargeInventoryDetailsReducer.mrcInformationInitialState
            , equipmentInformation: rechargeInventoryDetailsReducer.equipmentInformationInitialState
        }
        , outputConfigurationDetailsForm: {
            outputConfiguration: outputConfigurationDetailsReducer.outputConfigurationInitialState
            , circuitOutputScope: outputConfigurationDetailsReducer.circuitOutputScopeInitialState
            , equipmentOutputScope: outputConfigurationDetailsReducer.equipmentOutputScopeInitialState
            , otcOutputScope: outputConfigurationDetailsReducer.otcOutputScopeInitialState
            , outputColumnScope: outputConfigurationDetailsReducer.outputColumnScopeInitialState
            , multipleOutputColumnScope: outputConfigurationDetailsReducer.multipleOutputColumnScopeModelInitialState
        }
    })
});

export default rootReducer;
